import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";
import { JOIN_URL } from "../../data/content";

export const PricingHook = () => {
  return (
    <section className="relative bg-[#0b1528] py-24 sm:py-32 px-5 sm:px-8 overflow-hidden" data-testid="pricing-hook-section">
      <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(circle at 50% 0%, rgba(0,240,255,0.12), transparent 60%)" }} />
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <ScrollReveal>
          <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">
            The ₹1 Promise
          </span>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <div className="mt-8 flex items-center justify-center gap-3 sm:gap-5">
            <motion.span
              className="font-display font-extrabold text-gradient-cyan text-[5rem] sm:text-[8rem] leading-none"
              initial={{ scale: 0.85, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              data-testid="pricing-hero-number"
            >
              ₹1
            </motion.span>
            <span className="font-display font-bold text-lg sm:text-2xl text-slate-300 uppercase text-left">
              per day <br /> for your health
            </span>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <p className="mt-8 font-display uppercase text-white font-bold text-xl sm:text-2xl">
            ₹365 = 365 Days of Transformation.
          </p>
          <p className="text-slate-400 mt-3 max-w-lg mx-auto text-sm sm:text-base">
            365 workouts. 365 days of guidance. One powerful transformation journey — for less than the cost of a cup of chai.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.3}>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {["Stronger Body", "Healthier Mind", "Better Gut Health", "More Energy", "Better Sleep", "Stronger Habits"].map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/25 px-4 py-1.5 text-xs font-medium text-cyan-200"
                data-testid={`pricing-tag-${tag.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <Check size={12} /> {tag}
              </span>
            ))}
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.4}>
          <a
            href={JOIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-12 group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-cyan-400 to-blue-600 px-8 py-4 text-sm font-bold uppercase tracking-wide text-[#020617] shadow-[0_0_35px_rgba(0,240,255,0.4)] hover:shadow-[0_0_50px_rgba(0,240,255,0.6)] hover:scale-[1.03] transition-all duration-300"
            data-testid="pricing-cta-active360"
          >
            Get Active360 for ₹365
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" />
          </a>
        </ScrollReveal>
      </div>
    </section>
  );
};
